// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__33jW2","errorLogs":"styles_errorLogs__stQrG"};